import { render } from "./WorldMap.vue?vue&type=template&id=fdf2029c"
import script from "./WorldMap.vue?vue&type=script&lang=js"
export * from "./WorldMap.vue?vue&type=script&lang=js"
script.render = render

export default script